export const HOT_STORIES_DEFAULT_BUTTON_TITLE = "לכתבה המלאה"
export const HOT_STORIES_MIN_ITEMS = 3
export const HOT_STORIES_BG = "#0c1c3a"
export const HOT_STORIES_ACCENT = "#de1a1a"
export const HOT_STORIES_DEFAULT_TAB_TITLE = "הסיפורים החמים"
export const HOT_STORIES_DEFAULT_MORE_TITLE = "כתבות נוספות"
export const HOT_STORIES_TITLE_SUBTITLE_MAX_LINES = 7

function parseLineHeight(el: HTMLElement, fallback: number) {
    const style = window.getComputedStyle(el)
    const lineHeight = parseFloat(style.lineHeight)
    if (lineHeight > 0) {
        return lineHeight
    }
    const fontSize = parseFloat(style.fontSize)
    return fontSize > 0 ? fontSize * 1.3 : fallback
}

function applyLineClamp(el: HTMLElement, lines: number, lineHeight: number) {
    el.style.removeProperty("display")
    el.style.setProperty("--hot-stories-line-clamp", String(lines))
    el.style.maxHeight = `${lines * lineHeight}px`
}

function clearLineClamp(el: HTMLElement) {
    el.style.display = "block"
    el.style.overflow = "visible"
    el.style.maxHeight = "none"
    el.style.removeProperty("--hot-stories-line-clamp")
}

export function syncHotStoriesTitleSubClamp(root: HTMLElement | null, maxLines = HOT_STORIES_TITLE_SUBTITLE_MAX_LINES) {
    if (!root || typeof window === "undefined") {
        return
    }
    if (root.getBoundingClientRect().width < 1) {
        return
    }
    const title = root.querySelector(".hotStoriesTitle") as HTMLElement
    const subTitle = root.querySelector(".hotStoriesSubTitle") as HTMLElement
    if (!title) {
        return
    }

    const titleLineHeight = parseLineHeight(title, 42)
    clearLineClamp(title)

    const naturalTitleLines = Math.max(1, Math.round(title.getBoundingClientRect().height / titleLineHeight))
    const titleLines = Math.min(maxLines, naturalTitleLines)
    applyLineClamp(title, titleLines, titleLineHeight)

    if (!subTitle) {
        return
    }

    const remaining = maxLines - titleLines
    if (remaining <= 0) {
        subTitle.style.display = "none"
        subTitle.style.removeProperty("--hot-stories-line-clamp")
        subTitle.style.maxHeight = "0px"
        return
    }

    subTitle.style.removeProperty("display")
    const subLineHeight = parseLineHeight(subTitle, 31)
    applyLineClamp(subTitle, remaining, subLineHeight)
}
